import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAuthorizeSandbox } from '../../website/services/payment/authorizeEnvironment';
import CustomPlanInviteAcceptView from '../components/CustomPlanInviteAcceptView';
import { mockCustomPlanInvite } from '../fixtures/mockCustomPlanInvite';
import {
  formatBillingLabel,
  getCustomPlanTotals,
} from '../utils/customPlanPricing';
import '../styles/custom-plan-invite.css';

const EMPTY_BILLING = {
  street: '',
  city: '',
  state: '',
  zipCode: '',
};

export default function CustomPlanInviteAcceptTestPage() {
  const navigate = useNavigate();
  const plan = mockCustomPlanInvite;

  const [firstName, setFirstName] = useState('Jane');
  const [lastName, setLastName] = useState('Doe');
  const [companyName, setCompanyName] = useState(plan.customerLabel);
  const [email] = useState(plan.email);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [billingAddress, setBillingAddress] = useState(EMPTY_BILLING);
  const [payment, setPayment] = useState(null);
  const [pwScore, setPwScore] = useState(0);
  const [showPw, setShowPw] = useState(false);
  const [showPw2, setShowPw2] = useState(false);
  const [error, setError] = useState('');
  const [allowTestCards] = useState(() => isAuthorizeSandbox());

  const totals = useMemo(() => getCustomPlanTotals(plan.terms), [plan.terms]);
  const billingLabel = formatBillingLabel(plan.terms.billingCycle);

  const handlePasswordChange = (value) => {
    setPassword(value);
    let score = 0;
    if (value.length >= 6) score += 1;
    if (/[A-Z]/.test(value) && /[a-z]/.test(value)) score += 1;
    if (/\d/.test(value)) score += 1;
    if (/[^A-Za-z0-9]/.test(value) || value.length >= 12) score += 1;
    setPwScore(score);
  };

  const handleBillingChange = (event) => {
    const { name, value } = event.target;
    setBillingAddress((prev) => ({ ...prev, [name]: value }));
  };

  const handleAccept = () => {
    setError('');
  };

  const pwLabel = ['Too weak', 'Weak', 'Fair', 'Good', 'Strong'][pwScore];
  const pwClass = ['weak', 'weak', 'fair', 'good', 'strong'][pwScore];

  return (
    <CustomPlanInviteAcceptView
      plan={plan}
      totals={totals}
      billingLabel={billingLabel}
      email={email}
      firstName={firstName}
      lastName={lastName}
      companyName={companyName}
      password={password}
      confirmPassword={confirmPassword}
      billingAddress={billingAddress}
      showPassword={showPw}
      showConfirmPassword={showPw2}
      passwordScore={pwScore}
      passwordLabel={pwLabel}
      passwordStrengthClass={pwClass}
      error={error}
      allowTestCards={allowTestCards}
      submitDisabled={!payment}
      isPreview
      onFirstNameChange={setFirstName}
      onLastNameChange={setLastName}
      onCompanyNameChange={setCompanyName}
      onPasswordChange={handlePasswordChange}
      onConfirmPasswordChange={setConfirmPassword}
      onTogglePassword={() => setShowPw((value) => !value)}
      onToggleConfirmPassword={() => setShowPw2((value) => !value)}
      onBillingChange={handleBillingChange}
      onPaymentChange={setPayment}
      onAccept={handleAccept}
      onCancel={() => navigate('/app/login')}
    />
  );
}
